/**
 * Generates a date string in the YYYY-MM-DD format.
 *
 * @param {Date} date
 * @returns {string}
 * @memberof DateService
 */
export var convertToYYYYMMDD = function (date) {
    if (date.getFullYear() < 2000) {
        date.setFullYear(date.getFullYear() + 100);
    }
    return date.toISOString().split('T')[0];
};
/**
 * Return a timestamp based on the current date.
 *
 * @returns {string}
 * @memberof Date
 */
export var createTimeStamp = function () {
    var date = new Date();
    var hours = date.getHours();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    var hours12 = hours % 12 || 12; // converts to 12-hour format
    var month = date.toLocaleString('en-us', { month: 'long' });
    var day = date.getDate().toString().padStart(2, '0');
    var year = date.getFullYear();
    var hour = hours12.toString().padStart(2, '0');
    var minute = date.getMinutes().toString().padStart(2, '0');
    return "".concat(month, "-").concat(day, "-").concat(year, "_").concat(hour, ":").concat(minute, "-").concat(ampm);
};
